/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Case_Remove_Liable_VehicleInputs */

const en_case_remove_liable_vehicle = /** @type {(inputs: Case_Remove_Liable_VehicleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove liable vehicle ${i?.number}`)
};

const pt_br2_case_remove_liable_vehicle = /** @type {(inputs: Case_Remove_Liable_VehicleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remover veículo terceiro ${i?.number}`)
};

/**
* | output |
* | --- |
* | "Remove liable vehicle {number}" |
*
* @param {Case_Remove_Liable_VehicleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_remove_liable_vehicle = /** @type {((inputs: Case_Remove_Liable_VehicleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Remove_Liable_VehicleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_remove_liable_vehicle(inputs)
	return pt_br2_case_remove_liable_vehicle(inputs)
});